module.exports = "/packs/media/images/opt2icon-ae2147020f032584e645488a50566879.png";